(function () {
  // ---------- scroll reveal ----------
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  // ---------- mobile menu ----------
  var burger = document.querySelector('.burger');
  var menu = document.querySelector('.mobile-menu');
  if (burger && menu) {
    burger.addEventListener('click', function () {
      menu.classList.toggle('open');
      burger.setAttribute('aria-expanded', menu.classList.contains('open'));
    });
  }

  // ---------- homepage frame swatch toggle ----------
  var swatches = document.querySelectorAll('.frame-toggle .swatch');
  var heroCap = document.querySelector('.hero .cap');
  swatches.forEach(function (sw) {
    sw.addEventListener('click', function () {
      swatches.forEach(function (s) { s.classList.remove('active'); });
      sw.classList.add('active');
      if (heroCap) {
        var f = sw.getAttribute('data-frame') === 'white' ? 'WHITE FRAME' : 'BLACK FRAME';
        heroCap.innerHTML = '<b>HOLO RARE</b> \u00b7 16\u00d724IN \u00b7 ' + f;
      }
    });
  });

  // ---------- product page: quantity stepper ----------
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v += (b.dataset.step === 'up' ? 1 : -1);
        if (v < 1) v = 1;
        input.value = v;
      });
    });
  });

  // ========== CART DRAWER ==========
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');

  function formatMoney(cents) {
    var fmt = window.themeMoneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      var whole = Math.round(cents / 100).toString();
      var dec = (cents / 100).toFixed(2);
      switch (key) {
        case 'amount': return dec;
        case 'amount_no_decimals': return whole;
        case 'amount_with_comma_separator': return dec.replace('.', ',');
        case 'amount_no_decimals_with_comma_separator': return whole;
        default: return dec;
      }
    });
  }

  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('show'); }); }
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (overlay) { overlay.classList.remove('show'); setTimeout(function () { overlay.hidden = true; }, 300); }
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!drawer) return;
    var items = drawer.querySelector('[data-cart-items]');
    var empty = drawer.querySelector('[data-cart-empty]');
    var foot = drawer.querySelector('[data-cart-foot]');
    if (cart.item_count === 0) {
      items.innerHTML = ''; empty.hidden = false; foot.hidden = true; return;
    }
    empty.hidden = true; foot.hidden = false;
    items.innerHTML = cart.items.map(function (item) {
      var img = item.image ? '<img src="' + item.image + '" alt="">' : '';
      var props = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          if (k.charAt(0) === '_' || !item.properties[k]) return;
          var v = String(item.properties[k]);
          if (v.indexOf('/uploads/') > -1) { v = '<a href="' + v + '" target="_blank" rel="noopener">view upload</a>'; }
          props += '<div>' + k + ': ' + v + '</div>';
        });
      }
      var vt = (item.variant_title && item.variant_title !== 'Default Title') ? '<div>' + item.variant_title + '</div>' : '';
      return '<div class="cd-item" data-key="' + item.key + '">' +
        '<a class="cd-thumb" href="' + item.url + '">' + img + '</a>' +
        '<div class="cd-info"><div class="cd-title">' + item.product_title + '</div>' +
        '<div class="cd-props">' + vt + props + '</div>' +
        '<div class="cd-qty"><button type="button" data-dq="down" aria-label="Decrease">\u2212</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-dq="up" aria-label="Increase">+</button>' +
        '<button type="button" class="cd-remove" data-remove aria-label="Remove">Remove</button></div>' +
        '</div>' +
        '<div class="cd-price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>';
    }).join('');
    var sub = drawer.querySelector('[data-cart-subtotal]');
    if (sub) sub.innerHTML = formatMoney(cart.total_price);
  }

  function changeItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function fetchAndOpen() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { renderCart(c); openDrawer(); });
  }

  // open drawer from any cart toggle (header bag). Falls back to /cart if JS disabled.
  document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); fetchAndOpen(); });
  });

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
      var itemEl = e.target.closest('.cd-item');
      if (!itemEl) return;
      var key = itemEl.dataset.key;
      var span = itemEl.querySelector('.cd-qty span');
      var cur = parseInt(span.textContent, 10) || 1;
      if (e.target.closest('[data-remove]')) { changeItem(key, 0); }
      else if (e.target.dataset.dq === 'up') { changeItem(key, cur + 1); }
      else if (e.target.dataset.dq === 'down') { changeItem(key, Math.max(0, cur - 1)); }
    });
  }
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // ---------- product page: AJAX add-to-cart (keeps file upload) ----------
  var pForm = document.querySelector('.product-form');
  if (pForm) {
    var fileInput = pForm.querySelector('input[type=file][required]');
    pForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (fileInput && !fileInput.files.length) {
        fileInput.focus();
        var hint = pForm.querySelector('.uploader .hint');
        if (hint) { hint.textContent = 'Please choose a card image before adding to cart.'; hint.style.color = 'var(--gold)'; }
        return;
      }
      var btn = pForm.querySelector('[name=add]');
      var orig = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding\u2026'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(pForm) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { throw res.d; }
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) { renderCart(cart); openDrawer(); })
        .catch(function (err) { alert(err && err.description ? err.description : 'Sorry, that could not be added to the cart.'); })
        .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = orig; } });
    });
  }
})();